import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body", "icon"]
  static values = { open: Boolean }

  connect() {
    this.update()
  }

  toggle() {
    this.openValue = !this.openValue
  }

  openValueChanged() {
    this.update()
  }

  update() {
    if (this.openValue) {
      this.bodyTarget.style.maxHeight = this.bodyTarget.scrollHeight + "px"
      this.iconTarget.style.transform = "rotate(180deg)"
    } else {
      this.bodyTarget.style.maxHeight = "0px"
      this.iconTarget.style.transform = "rotate(0deg)"
    }
  }
}
